import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import './AdministratorSidebar.css';
import AdminSidebar from "./AdminSidebar";
import AdministratorSidebar from "./AdministratorSidebar";
import UserSidebar from "./UserSidebar";

const DocsShip = () => {
    const navigate = useNavigate();
    const [userType, setUserType] = useState("");
    const [userFullName, setUserFullName] = useState("");
    const [userName, setUserName] = useState("");
    const [soldCars, setSoldCars] = useState([]);
    const [selectedStockId, setSelectedStockId] = useState("");
    const [carDetails, setCarDetails] = useState(null);
    const [documents, setDocuments] = useState({
        doc1: null,
        doc2: null,
        doc3: null,
        doc4: null,
        doc5: null,
        doc6: null
    });
    const [statusChecks, setStatusChecks] = useState({
        doc1: false,
        doc2: false,
        doc3: false,
        doc4: false,
        doc5: false,
        doc6: false
    });
    const [shippingInfo, setShippingInfo] = useState({
        vessel_name: "",
        shipping_line: "",
        etd: "",
        eta: "",
        courier_company: "",
        courier_tracking: ""
    });
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(true);
    const [showAlert, setShowAlert] = useState(false);

    useEffect(() => {
        const storedUserType = localStorage.getItem("usertype");
        const storedUserName = localStorage.getItem("userName");
        const storedFName = localStorage.getItem("fname");
        const storedLName = localStorage.getItem("lname");

        if (!storedUserType) {
            navigate("/login");
        } else {
            setUserType(storedUserType);
            setUserName(storedUserName);
            if (storedFName && storedLName) {
                setUserFullName(`${storedFName} ${storedLName}`);
            } else if (storedFName) {
                setUserFullName(storedFName);
            } else {
                setUserFullName(storedUserName);
            }
            fetchSoldCars();
        }
    }, [navigate]);

    const fetchSoldCars = async () => {
        try {
            const response = await fetch("https://api.saadmotors.com/getSoldCars.php");
            const data = await response.json();

            if (data.success) {
                setSoldCars(data.cars);
                if (data.cars.length > 0) {
                    const prevSelected = selectedStockId || data.cars[0].stock_id;
                    const exists = data.cars.some(car => car.stock_id === prevSelected);
                    const newSelected = exists ? prevSelected : data.cars[0].stock_id;

                    setSelectedStockId(newSelected);
                    fetchCarDetails(newSelected);
                }
            } else {
                setMessage(data.message);
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching sold cars:", error);
            setMessage("Error fetching sold cars");
            setLoading(false);
        }
    };

    const fetchCarDetails = async (stockId) => {
        if (!stockId) return;

        try {
            const response = await fetch(`https://api.saadmotors.com/getDocuments.php?stockId=${stockId}`);
            const data = await response.json();

            if (data.success) {
                setCarDetails(data.car);
                setStatusChecks({
                    doc1: data.car.doc1_status === "checked",
                    doc2: data.car.doc2_status === "checked",
                    doc3: data.car.doc3_status === "checked",
                    doc4: data.car.doc4_status === "checked",
                    doc5: data.car.doc5_status === "checked",
                    doc6: data.car.doc6_status === "checked"
                });
                setShippingInfo({
                    vessel_name: data.car.vessel_name || "",
                    shipping_line: data.car.shipping_line || "",
                    etd: data.car.etd ? data.car.etd.split(' ')[0] : "",
                    eta: data.car.eta ? data.car.eta.split(' ')[0] : "",
                    courier_company: data.car.courier_company || "",
                    courier_tracking: data.car.courier_tracking || ""
                });
                setMessage("");
            } else {
                setMessage(data.message);
                setCarDetails(null);
            }
        } catch (error) {
            console.error("Error fetching car details:", error);
            setMessage("Error fetching car details");
        }
    };

    const handleStockIdChange = (e) => {
        const stockId = e.target.value;
        setSelectedStockId(stockId);
        fetchCarDetails(stockId);
    };

    const handleFileChange = (e, docField) => {
        setDocuments({
            ...documents,
            [docField]: e.target.files[0]
        });
    };

    const handleCheckboxChange = (e, docField) => {
        setStatusChecks({
            ...statusChecks,
            [docField]: e.target.checked
        });
    };

    const handleShippingInfoChange = (e) => {
        const { name, value } = e.target;
        setShippingInfo(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!selectedStockId || !carDetails) {
            setMessage("Please select a vehicle first");
            return;
        }

        const formData = new FormData();
        formData.append("stockId", selectedStockId);

        // Append files if they exist
        Object.entries(documents).forEach(([key, file]) => {
            if (file) {
                formData.append(key, file);
            }
        });

        // Append status checks
        Object.entries(statusChecks).forEach(([key, checked]) => {
            formData.append(`${key}_status`, checked ? "checked" : "");
        });

        // Append shipping info
        Object.entries(shippingInfo).forEach(([key, value]) => {
            formData.append(key, value || ""); // Ensure empty strings are sent
        });

        try {
            const response = await fetch("https://api.saadmotors.com/updateDocuments.php", {
                method: "POST",
                body: formData
            });

            const data = await response.json();

            if (data.success) {
                setShowAlert(true);
                setMessage("Documents and shipping info updated successfully!");
                fetchCarDetails(selectedStockId);
                setDocuments({
                    doc1: null,
                    doc2: null,
                    doc3: null,
                    doc4: null,
                    doc5: null,
                    doc6: null
                });
                setTimeout(() => setShowAlert(false), 3000);
            } else {
                setMessage(data.message || "Error updating documents and shipping info");
            }
        } catch (error) {
            console.error("Error updating documents:", error);
            setMessage("Error updating documents and shipping info");
        }
    };

    const handleClearDocument = async (docField) => {
        if (!selectedStockId) {
            setMessage("Please select a vehicle first");
            return;
        }

        const formData = new FormData();
        formData.append("stockId", selectedStockId);
        formData.append(docField, ""); // Send empty string to clear the document

        try {
            const response = await fetch("https://api.saadmotors.com/updateDocuments.php", {
                method: "POST",
                body: formData
            });

            const data = await response.json();

            if (data.success) {
                setMessage(`Document ${docField} cleared successfully`);
                fetchCarDetails(selectedStockId); // Refresh car details
            } else {
                setMessage(data.message || "Error clearing document");
            }
        } catch (error) {
            console.error("Error clearing document:", error);
            setMessage("Error clearing document");
        }
    };

    const logout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("email");
        localStorage.removeItem("userName");
        localStorage.removeItem("usertype");
        localStorage.removeItem("fname");
        localStorage.removeItem("lname");
        navigate("/login");
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <div className="admin-container">
            <div className="sidebar-container">
                {userType === "administrator" && <AdministratorSidebar />}
                {userType === "admin" && <AdminSidebar />}
                {userType === "user" && <UserSidebar />}
            </div>

            <div className="admin-content">
                <div className="adminnavbar">
                    <h1>Welcome to the Admin Panel, {userFullName}</h1>
                    <button onClick={logout} className="logoutbtn">
                        Logout
                    </button>
                </div>

                <div className="mainsection">
                    <h3>Documents and Shipping</h3>

                    <div className="document-upload-container p-4 border rounded bg-light">
                        {showAlert && (
                            <div className="alert alert-success alert-dismissible fade show">
                                Documents and shipping info for <strong>{selectedStockId}</strong> updated successfully!
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowAlert(false)}
                                    aria-label="Close"
                                ></button>
                            </div>
                        )}

                        {message && !showAlert && (
                            <div className="alert alert-danger">
                                {message}
                            </div>
                        )}

                        <div className="mb-4">
                            <label htmlFor="stockId" className="form-label fw-bold">Select Vehicle:</label>
                            <select
                                id="stockId"
                                className="form-select"
                                value={selectedStockId}
                                onChange={handleStockIdChange}
                                disabled={soldCars.length === 0}
                            >
                                {soldCars.length > 0 ? (
                                    soldCars.map((car) => (
                                        <option key={car.stock_id} value={car.stock_id}>
                                            {car.stock_id} - {car.client_name}
                                        </option>
                                    ))
                                ) : (
                                    <option value="">No sold vehicles found</option>
                                )}
                            </select>
                        </div>

                        {carDetails && (
                            <form onSubmit={handleSubmit}>
                                <div className="card p-4 mb-4">
                                    <div className="mb-4">
                                        <h4 className="fw-bold">{carDetails.maker} {carDetails.model} ({carDetails.year})</h4>
                                        <p className="text-muted">Stock ID: {carDetails.stock_id} &nbsp;&nbsp;&nbsp; Chassis #: {carDetails.vin}</p>
                                    </div>
                                </div>

                                <div className="card p-4 mb-4">
                                    <h5 className="mb-3">Documents</h5>
                                    <div className="row g-3">
                                        {[1, 2, 3, 4, 5, 6].map((num) => {
                                            const docField = `doc${num}`;
                                            const statusField = `${docField}_status`;
                                            const docUrl = carDetails[docField];
                                            const isPdf = docUrl && docUrl.toLowerCase().endsWith('.pdf');

                                            return (
                                                <div key={docField} className="col-md-4">
                                                    <div className="card h-100">
                                                        <div className="card-body">
                                                            <h6 className="card-title">Document {num}</h6>

                                                            {docUrl ? (
                                                                <div className="mb-3">
                                                                    {isPdf ? (
                                                                        <div className="d-flex align-items-center text-danger">
                                                                            <i className="bi bi-file-earmark-pdf fs-4 me-2"></i>
                                                                            <a
                                                                                href={`https://api.saadmotors.com/${docUrl}`}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                                className="text-decoration-none"
                                                                            >
                                                                                View PDF
                                                                            </a>
                                                                        </div>
                                                                    ) : (
                                                                        <a
                                                                            href={docUrl}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            className="btn btn-sm btn-outline-primary"
                                                                        >
                                                                            View Document
                                                                        </a>
                                                                    )}
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-outline-danger mt-2 w-100"
                                                                        onClick={() => handleClearDocument(docField)}
                                                                    >
                                                                        <i className="bi bi-trash me-2"></i>
                                                                        Clear Document
                                                                    </button>
                                                                </div>
                                                            ) : (
                                                                <div className="text-muted mb-3">No document available</div>
                                                            )}

                                                            <div className="mb-3">
                                                                <label
                                                                    htmlFor={`file-${docField}`}
                                                                    className="btn btn-sm btn-outline-secondary w-100"
                                                                >
                                                                    <i className="bi bi-upload me-2"></i>
                                                                    Upload New Document
                                                                </label>
                                                                <input
                                                                    type="file"
                                                                    id={`file-${docField}`}
                                                                    onChange={(e) => handleFileChange(e, docField)}
                                                                    accept=".pdf,.jpg,.jpeg,.png"
                                                                    className="d-none"
                                                                />
                                                            </div>

                                                            <div className="form-check form-switch">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id={`check-${docField}`}
                                                                    checked={statusChecks[docField]}
                                                                    onChange={(e) => handleCheckboxChange(e, docField)}
                                                                />
                                                                <label className="form-check-label" htmlFor={`check-${docField}`}>
                                                                    Mark as Verified
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>

                                <div className="card shipping-info-card p-4 mb-4">
                                    <h5 className="mb-3">Shipping Information</h5>
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <label className="form-label">Vessel Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="vessel_name"
                                                value={shippingInfo.vessel_name}
                                                onChange={handleShippingInfoChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">Shipping Line</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="shipping_line"
                                                value={shippingInfo.shipping_line}
                                                onChange={handleShippingInfoChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">Estimated Departure (ETD)</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="etd"
                                                value={shippingInfo.etd}
                                                onChange={handleShippingInfoChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">Estimated Arrival (ETA)</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="eta"
                                                value={shippingInfo.eta}
                                                onChange={handleShippingInfoChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">Courier Company</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="courier_company"
                                                value={shippingInfo.courier_company}
                                                onChange={handleShippingInfoChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">Tracking Number</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="courier_tracking"
                                                value={shippingInfo.courier_tracking}
                                                onChange={handleShippingInfoChange}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-4 text-end">
                                    <button type="submit" className="btn btn-primary px-4">
                                        <i className="bi bi-save me-2"></i>
                                        Update All Information
                                    </button>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DocsShip;